import analytics from '@utils/analytics';
import BaseComponent from '../base/baseComponent';
export default class AccordionComponent extends BaseComponent {
    constructor(element) {
        super(element);
        // this.$log(this.$el);
        this.accordionHeaders = this.$el.querySelectorAll(this.SELECTORS.accordionHeader);
        // handle init if data attribute is present
    }
    // get Messages() {
    // return {
    // [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
    // };
    // }
    get SELECTORS() {
        return {
            accordionHeader: '[aria-expanded]',
        };
    }
    get ATTRIBUTES() {
        return {
            isExpanded: 'aria-expanded',
        };
    }
    // setPanelsHeight() {
    //   this.accordionHeaders.forEach((el) => {
    //     const accordionPanel = el.nextElementSibling as HTMLElement;
    //     accordionPanel.style.height = `${(accordionPanel.children[0] as HTMLElement)?.scrollHeight}px`;
    //   });
    // }
    disableScroll() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        document.documentElement.classList.add('initial-scroll');
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        window.onscroll = () => {
            window.scrollTo(scrollLeft, scrollTop);
        };
    }
    enableScroll() {
        document.documentElement.classList.remove('initial-scroll');
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        window.onscroll = () => { };
    }
    initAccordion(isFooter) {
        this.accordionHeaders.forEach((el) => {
            this.$on('click', (e) => this.toggleAccordion(e, el, isFooter), el);
            this.$on('keydown', (e) => {
                if (e.key == ' ' || e.key == 'Enter') {
                    this.toggleAccordion(e, el, isFooter);
                }
            }, el);
        });
    }
    toggleAccordion(e, el, isFooter) {
        var _a;
        e.preventDefault();
        if (el.getAttribute(this.ATTRIBUTES.isExpanded) == 'true') {
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'false');
        }
        else {
            const dataAnalytics = el.getAttribute('data-analytics');
            if (dataAnalytics) {
                (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(JSON.parse(dataAnalytics));
            }
            isFooter ? analytics.footerOpen(el.dataset.titleAnalytics || el.innerText) : null;
            // this.setPanelsHeight();
            this.accordionHeaders.forEach((el) => el.setAttribute(this.ATTRIBUTES.isExpanded, 'false'));
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'true');
        }
    }
}
